// softwareBoardRouteEntry.tsx
import { createEntry } from '@atlassian/jira-route-entry';
import { aiFirstCreateRoute } from '@atlassian/jira-router-routes-ai-first-create-routes/src/aiFirstCreateRoute.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { aiFirstCreateEntryPoint } from '@atlassian/jira-spa-apps-ai-first-create/entrypoint.tsx';

const AIFCEmbedPageEntryPoint = createChromelessEntryPoint({
	main: aiFirstCreateEntryPoint,
});

export const aiFirstCreateRouteEntry = createEntry(
	// baseRoute refers to the static route definition above
	aiFirstCreateRoute,
	() => ({
		group: 'aifc',
		layout: chromelessLayout,
		entryPoint: () => AIFCEmbedPageEntryPoint,
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-ai-first-create-entries/src/aiFirstCreateRouteEntry.tsx',
				whichExportToUse: 'aiFirstCreateRouteEntry',
			},
			enabled: true,
		},
	}),
);
